import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentFailed = () => {
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            navigate('/');
        }, 3000);
    }, [navigate]);

    return (
        <div>
            <h1>Payment Failed</h1>
            <p>Unfortunately, your payment could not be processed. Please try again later or contact support.</p>
        </div>
    );
};

export default PaymentFailed;
